
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/science",
      function () {
        return require("private-next-pages/science.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/science"])
      });
    }
  